import { render, staticRenderFns } from "./ModalEditWebhook.vue?vue&type=template&id=28a61731"
import script from "./ModalEditWebhook.vue?vue&type=script&lang=js"
export * from "./ModalEditWebhook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports